<template>
  <button type="button"
          class="btn btn-lg bc-choice"
          :class="selected ? 'btn-primary' : 'btn-outline-primary'"
          :disabled="disabled"
          :aria-pressed="String(!!selected)"
          :data-zero="zero ? '' : null"
          @click="$emit('click', $event)">
    <span class="bc-choice-label">{{ label }}</span>
    <small v-if="description">{{ description }}</small>
    <small v-if="count != null">
      <span class="bc-mono">{{ countText }}</span> {{ $t("broadcast.people") }}
    </small>
  </button>
</template>

<script>
// Full-width choice CTA of the บรอดแคสต์ popup: bold label, optional description, optional "N คน".
// A count of 0 dims the button (still tappable: the screen decides what zero means).
export default {
  name: "BcChoiceButton",
  props: {
    label: { type: String, required: true },
    description: { type: String, default: "" },
    count: { type: Number, default: null },
    selected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    zero() {
      return this.count === 0;
    },
    countText() {
      return Number(this.count).toLocaleString("en-US");
    },
  },
};
</script>

<style lang="scss" scoped>
.bc-choice {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 52px;
  margin: 0 0 0.6rem;
  padding: 0.5rem 1rem;
  font-weight: 700;
  text-align: center;
  line-height: 1.3;

  small {
    display: block;
    margin-top: 0.1rem;
    font-weight: 400;
    font-size: 0.8125rem;
    opacity: 0.9;
  }

  &[data-zero] {
    opacity: 0.55;
  }
}

.bc-mono {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-variant-numeric: tabular-nums;
}

body.--dark .btn-outline-primary.bc-choice {
  color: #8cc8f5;
  border-color: #8cc8f5;

  &:hover:not(:disabled) {
    color: #fff;
  }
}
</style>

